import axios from 'axios'
import { BASE_URL } from '@/service_urls'

const readinessDashboard = {
  getActiveLearnerCandidates: (customerUid, organisationId) => {
    const params = new URLSearchParams()
    if (customerUid) params.append('customer_uid', customerUid)
    if (organisationId) params.append('organisation_id', organisationId)
    return axios.get(`${BASE_URL}/active_learner_candidates_view/?${params.toString()}`)
  },

  getActiveWorkforceCandidates: (customerUid, organisationId) => {
    const params = new URLSearchParams()
    if (customerUid) params.append('customer_uid', customerUid)
    if (organisationId) params.append('organisation_id', organisationId)
    return axios.get(`${BASE_URL}/active_workforce_candidates_view/?${params.toString()}`)
  },

  getLinkedCount: (customerUid) => {
    return axios.get(`${BASE_URL}/active_workforce_candidates_view/linked_count?customer_uid=${customerUid}`)
  },

  getLearnerLinkedCount: (customerUid) => {
    return axios.get(`${BASE_URL}/active_learner_candidates_view/linked_count?customer_uid=${customerUid}`)
  },
}

export default readinessDashboard
